/** Transport limits apply to UTF-8 JSON bytes, independently of event semantics. */
export const NORMALIZED_FRAME_MAX_BYTES = 32768;
export const NORMALIZED_EVENT_MAX_BYTES = 131072;
export const NORMALIZED_FRAGMENT_BYTES = 16384;
export const NORMALIZED_FRAGMENT_VERSION = 1;
export const NORMALIZED_FRAGMENT_TTL_MS = 10000;
//# sourceMappingURL=normalized-transport-types.js.map